module.exports = __webpack_public_path__ + "static/img/cont60 (2).e4935a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont60 (2).jpg
// module id = Q3gb
// module chunks = 0